var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.winnersGrouped),function(group,index){return _c('v-sheet',{key:index},[(index)?_c('h3',{staticClass:"mt-3"},[_vm._v(_vm._s(index))]):_vm._e(),_c('ContestWinnersGroup',{attrs:{"winnersGroup":group}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }